<template>
  <v-stepper
    v-if="isDesktop"
    key="desktop-stepper"
    elevation="0"
    class="lifecycle-stepper"
    alt-labels
  >
    <v-stepper-header>
      <fragment
        v-for="(step, s) in steps"
        :key="s"
      >
        <v-divider v-if="s !== 0" />
        <v-stepper-step
          step=""
          :complete="isStepComplete(s)"
          color="primary"
        >
          <span :style="{ fontWeight: step.headerBold ? 'bold' : undefined }">
            {{ step.header }}
          </span>
          <div
            v-if="step.subheader !== null"
            class="subheader"
            :style="{ fontWeight: step.subHeaderBold ? 'bold' : undefined }"
          >
            {{ step.subHeader }}
          </div>
        </v-stepper-step>
      </fragment>
    </v-stepper-header>
  </v-stepper>
  <v-stepper
    v-else
    key="mobile-stepper"
    elevation="0"
    class="lifecycle-stepper"
    vertical
  >
    <fragment
      v-for="(step, s) in steps"
      :key="s"
    >
      <v-stepper-step
        step=""
        :complete="isStepComplete(s)"
        color="primary"
      >
        <span :style="{ fontWeight: step.headerBold ? 'bold' : undefined }">
          {{ step.header }}
        </span>
        <div
          v-if="step.subheader !== null"
          class="subheader"
          :style="{ fontWeight: step.subHeaderBold ? 'bold' : undefined }"
        >
          {{ step.subHeader }}
        </div>
      </v-stepper-step>
      <v-stepper-content :step="s + 1" />
    </fragment>
  </v-stepper>
</template>

<script lang="ts">
	import { defineComponent, PropType } from 'vue'
  import { Fragment } from 'vue-fragment';

	export default defineComponent({
    components: {
      Fragment,
    },
		props: {
			steps: {
				type: Array as PropType<StepDefinition[]>,
        required: true,
			},
			currentStep: {
				type: Number,
				required: true,
			},
		},
		computed: {
			isDesktop() {
        const bp = this.$vuetify.breakpoint.name;
				switch(bp) {
				case 'xl':
				case 'lg':
				case 'md':
          console.log(`isDesktop: bp = ${bp}, result = true`);
					return true;
				case 'sm':
				case 'xs':
				default:
          console.log(`isDesktop: bp = ${bp}, result = false`);
					return false;
				}
			}
		},
		methods: {
			isStepComplete(stepIndex: number) {
				switch(stepIndex) {
					case 0:
						return this.currentStep >= 0 && this.steps && !!this.steps[0]?.subHeader;
					case 1:
						return this.currentStep >= 1;
					case 2:
						return this.currentStep >= 2 && this.steps && !!this.steps[2]?.subHeader;
					default:
						return false;
				}
			}
		}
	});

  export interface StepDefinition {
    header: string;
    headerBold?: boolean;
    subHeader: string | null;
    subHeaderBold?: boolean;
  }
</script>

<style>
@media (min-width: 600px) {
  .lifecycle-stepper .v-stepper__label {
    text-align: center;
  }
}
</style>
